export default __webpack_public_path__ + "static/media/CollapseAllIcon.6bb40290.svg";